import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent.vue?vue&type=template&id=665f8128&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent.vue?vue&type=style&index=0&id=665f8128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f8128",
  null
  
)

export default component.exports